import React from 'react';

const CustomTooltip = ({
  active,
  payload
}) => {
  if (active && payload) {
    return /*#__PURE__*/React.createElement("div", {
      className: "chart__tooltip"
    }, /*#__PURE__*/React.createElement("span", null, `${payload[0].payload.date}`, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, `${payload[0].payload.value}`)));
  }

  return null;
};

export default CustomTooltip;